import {
	FacebookShareButton,
	TwitterShareButton,
	EmailShareButton
} from "react-share"

import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope, faMailReply } from "@fortawesome/free-solid-svg-icons"

export default function SocialShare() {
	return (
		<div className="flex relative container mx-auto">
			<span className="inline-block mr-6 font-bold text-md text-action-primary-blue-100">Share</span>
			<FacebookShareButton
				url={window.location.href}
				className="mr-2"
			>
				<div className="w-6 h-6 flex items-center justify-center bg-sky-800 rounded-full">
					<FontAwesomeIcon
						icon={faFacebookF}
						color="#fff"
						fontSize={12}
					/>
				</div>
			</FacebookShareButton>
			<TwitterShareButton url={window.location.href} className="mr-2">
				<div className="w-6 h-6 flex items-center justify-center bg-sky-800 rounded-full">
					<FontAwesomeIcon
						icon={faTwitter}
						color="#fff"
						fontSize={12}
					/>
				</div>
			</TwitterShareButton>
			<EmailShareButton
				url={window.location.href}
				subject="Check out this article"
				body={`I found this article and thought you might be interested: ${window.location.href}`}
				className="mr-2"
			>
				<div className="w-6 h-6 flex items-center justify-center bg-sky-800 rounded-full">
					<FontAwesomeIcon
						icon={faEnvelope}
						color="#fff"
						fontSize={12}
					/>
				</div>
			</EmailShareButton>
		</div>
	)
}
